/**
 * RTWO Asset & Token Engine — Null Event Bus Adapter
 */

import type { AssetId, RTWOAssetEventType } from '../domain-models';
import type { IEventBusAdapter, EventBusAdapterStatus } from './event-bus-adapter-interface';

export class NullEventBusAdapter implements IEventBusAdapter {
  readonly adapterId = 'null-event-bus-adapter';
  readonly adapterName = 'Null Event Bus Adapter';

  async connect(): Promise<void> {}

  async disconnect(): Promise<void> {}

  getStatus(): EventBusAdapterStatus {
    return 'not_configured';
  }

  isReady(): boolean {
    return false;
  }

  async publishAssetEvent(
    _assetId: AssetId,
    _eventType: RTWOAssetEventType,
    _payloadReference: string,
    _transactionReference: string
  ) {
    return null;
  }
}
